/* eslint-disable */
import {
  mdiViewDashboard,
  mdiAccountAlert,
  mdiBusDoubleDecker,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiFaceAgent,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiSchool,
  mdiBookOpenVariant,
  mdiBookshelf,
  mdiBookOpenPageVariant,
  mdiBookPlusMultiple,
  mdiHammerScrewdriver,
  mdiFormatListBulletedType,
  mdiFormatLetterMatches,
  mdiNumeric9BoxMultiple,
  mdiNotebookEdit,
  mdiAccountDetails,
  mdiTimetable,
  mdiCalendarMonth,
  mdiTimelineClockOutline,
  mdiPuzzle,
  mdiConsoleNetworkOutline,
  mdiSoccer,
  mdiClipboardAccount,
  mdiClipboardAccountOutline,
  mdiQrcodeScan,
  mdiRunFast,
  mdiTrophyOutline
} from "@mdi/js";
// const roles = localStorage.getItem('roles')
const menuConsellor = [
  {
    to: "/comboard-dashboard",
    icon: mdiViewDashboard,
    label: "sidebar.dashboard",
  },
  {
    label: "Student",
    subLabel: "Submenus Student",
    icon: mdiAccountCircle,
    menu: [
      {
        to: "/students",
        label: "Students Data",
        icon: mdiAccountGroup,
      },
      {
        to: '/non-academic-activity',
        label: 'Non-Academic Activities',
        icon: mdiRunFast
      },
      {
        label: 'Student Achievement',
        to: '/student-achievement',
        icon: mdiTrophyOutline
      }
    ],
  },
  {
    label: "Permission Request",
    subLabel: "Submenus Teacher",
    icon: mdiFaceAgent,
    menu: [
      {
        to: "/permissions",
        label: "Permissions",
        icon: mdiFaceAgent,
      },
      {
        to: "/permission-reason",
        label: "Permission Reason",
        icon: mdiFaceAgent,
      },
    ],
  },
  {
    label: "Attendance",
    subLabel: "Submenus Attendance",
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: "/daily-attendance",
        label: "Daily Attendance",
        icon: mdiConsoleNetworkOutline,
      },
      {
        to: "/regular-subject-attendance",
        label: "Regular Subject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/parallel-subject",
        label: "Parallel Subject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/report-attendance-daily",
        label: "Daily Attendance Report",
        icon: mdiAccountAlert,
      },
      {
        to: "/assignment-special",
        label: "Special Assignment",
        icon: mdiBusDoubleDecker,
      },
    ],
  },
  {
    label: "Schedule",
    subLabel: "Submenus Schedule",
    icon: mdiTimetable,
    menu: [
      // 	{
      // 	to: '/schooltime',
      // 	label: 'School Time',
      // 	icon: mdiAvTimer
      // },
      // {
      // 	to: '/studytime',
      // 	label: 'Study Time',
      // 	icon: mdiAvTimer
      // },
      {
        to: "/schedule",
        label: "Schedule",
        icon: mdiTimetable,
      },
      {
        to: "/extracuricular-schedule",
        label: "Extracuricular Schedule",
        icon: mdiTimetable,
      },
      {
        to: "/calendar",
        label: "Calendar",
        icon: mdiCalendarMonth,
      },
    ],
  },

  {
    label: "Extracuricular",
    subLabel: "Submenus Extracuricular",
    icon: mdiSoccer,
    menu: [
      {
        to: "/extracuricular",
        label: "Extracuricular",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-group",
        label: "Extracuricular Group",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-student",
        label: "Student Extracuricular",
        icon: mdiAccountDetails,
      },
      {
        to: "/extracuricular-student-select",
        label: "Student Extracuricular Selection",
        icon: mdiAccountDetails,
      },
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ],
  },
  {
    label: "Teacher",
    subLabel: "Submenus Teacher",
    icon: mdiClipboardAccount,
    menu: [
      {
        to: "/teacher",
        label: "Teacher",
        icon: mdiClipboardAccountOutline,
      },
      {
        to: "/teacher-extracuricular",
        label: "Extracurricular Teacher",
        icon: mdiSoccer,
      },
      {
        to: "/teacher-note",
        label: "Teacher Note",
        icon: mdiAccountDetails,
      },
      // {
      // 	to: '/teacherjournal',
      // 	label: 'Teacher Journal',
      // 	icon: mdiFileDocument
      // }
    ],
  },
];
export default menuConsellor;
